import { Component } from './helper';

export const VTitle = Component((p: { text: string }) => {
	const r = Vue.ref(null);
	Vue.onMounted(() => {
		let el: HTMLElement = r.value;
		let parent = el.parentElement;
		// Move tooltip out to <body> so it escapes any backdrop-filter /
		// transform containing block (e.g. the frosted-glass rail).
		document.body.appendChild(el);
		parent.onmouseover = () => {
			var rect = parent.getBoundingClientRect();
			el.style.top = rect.top + rect.height / 2 + 'px';
			el.style.left = rect.left + rect.width + 10 + 'px';
			el.classList.add('active');
		};
		parent.onmouseout = () => {
			el.classList.remove('active');
		};
	});
	Vue.onUnmounted(() => {
		let el: HTMLElement = r.value;
		if (el && el.parentElement === document.body) el.remove();
	});

	return () => (
		<div ref={r} class="hover-title">
			{p.text}
		</div>
	);
});
